import React from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import { themes } from "../../themes/themes";
interface PropVal {
  name: string;
  designation: string;
  amount: any;
}
const EmployeeTicketHistoryARTile = ({
  designation,
  name,
  amount,
}: PropVal) => {
  return (
    <Box
      style={{
        backgroundColor: "#F5F5FA66",
        height: "auto",
        padding: "1em",
        borderRadius: "10px",
        marginTop: "1em",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box style={{ display: "flex" }}>
        <Box>
          <Avatar />
        </Box>
        <Box style={{ paddingLeft: "5px" }}>
          <Typography
            style={{
              fontFamily: "Lato",
              color: themes.darkBlue,
              fontSize: "0.875em",
              fontWeight: "bold",
            }}
          >
            {name}
          </Typography>
          <Typography
            style={{
              fontFamily: "Lato",
              color: themes.grey_colorDesignationAR,
              fontSize: "0.75em",
              fontWeight: "bold",
            }}
          >
            {designation}
          </Typography>
        </Box>
      </Box>
      <Box
        style={{
          padding: "4px",
          borderRadius: "4px",
          backgroundColor: "#F2E6F0",
        }}
      >
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.primaryMain,
            fontSize: "0.75em",
            fontWeight: "bold",
          }}
        >
          {amount}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmployeeTicketHistoryARTile;
